import Button from "@app/sharedComponents/Button/Button";
import { ThemedText, ThemedView } from "@app/theme";
import { formatIndianCurrency } from "@app/utils/utility";

const AutodebitInfo = ({chargesDue,interestDue,selectedAmount,onRepay}) =>{
    return(
        <ThemedView p="lg" backgroundColor="bg-surface-primary">
            <ThemedText variant="b2b" color="text-primary">Auto debit notification</ThemedText>
            <ThemedView 
                my="lg" 
                p="lg"
                backgroundColor="bg-surface-secondary" 
                borderRadius="sm"
                >
                <ThemedView flexDirection="row" flexWrap="wrap" mb="lg">
                    <ThemedText variant="b3r" color="text-primary">
                        Your scheduled auto debit of 
                        <ThemedText variant="b3b" color="text-primary"> ₹{formatIndianCurrency(Math.ceil((chargesDue||0)+(interestDue||0)))} </ThemedText>
                        (for due interest/charges) may still be executed
                    </ThemedText>
                </ThemedView>
                <ThemedText variant="b3r" color="text-primary">But no need to worry! We'll make sure it gets adjusted against your principal outstanding.</ThemedText>
            </ThemedView>
            <Button label={`Confirm and repay ₹${formatIndianCurrency(selectedAmount)}`} handlePress={onRepay}/>
        </ThemedView>

    )
}

export default  AutodebitInfo;